export const uploadDocumentsCustomStyles = {
  formWrapper: {
    padding: '0 !important',
    '& #document-upload-form': {
      padding: '0 !important',
    },
  },
  buttonsContainer: {
    marginTop: '0 !important',
  },
};
